module.exports = __webpack_public_path__ + "static/priviliges-3-e7e02af84b1b4d4daceab91621e9d6d5.png";